import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchLookup } from "../../redux/actions/lookupAction";

import { fetchAppConfig } from "../../redux/actions/appConfigActions";

const AppData = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (document.querySelector("#reactJS-page")) {
      document.querySelector("#reactJS-page").style.display = "none";
    }
    Promise.all([dispatch(fetchAppConfig()), dispatch(fetchLookup())]).then(
      () => {
        if (document.querySelector(".modal-backdrop"))
          document.querySelector(".modal-backdrop").remove();
        if (document.querySelector("#pleaseWaitDialog"))
          document.querySelector("#pleaseWaitDialog").style.display = "none";
        if (document.querySelector("#reactJS-page"))
          document.querySelector("#reactJS-page").style.display = "block";

        props.handleAppData(true);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default AppData;
